import { FC, useEffect } from 'react';
import { ModalBodyWrapper, ModalWrapper } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import ModalHeader from '../../../../legacy/React/Components/Common/ModalHeader';
import { useCloseButton } from '../../../../core/windowManager/hooks';
import { changeDocumentTitleLocalized } from '../../../../middleware';
import { ProductServiceOrderFormProps } from '../../types';
import ProductServiceOrderCreatePageBody from './ProductServiceOrderCreatePageBody';

const ProductServiceOrderCreatePage: FC<ProductServiceOrderFormProps> = (props) => {
    const closeButton = useCloseButton();
    const dispatch = useCommanderThunkDispatch();

    useEffect(() => {
        dispatch(changeDocumentTitleLocalized(TextKey.Order));
    }, [dispatch]);

    return (
        <ModalWrapper>
            <ModalHeader primaryAction={closeButton} title={<LocalizedText textKey={TextKey.Order} />} />
            <ModalBodyWrapper padded>
                <ProductServiceOrderCreatePageBody {...props} />
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};

export default ProductServiceOrderCreatePage;
